import React from "react";

import CustomersIcon from "./icon/Customers";
import DetailsIcon from "./icon/Details";
import PaymentsIcon from "./icon/Payments";
import ProductsIcon from "./icon/Products";
import SettingsIcon from "./icon/Settings";
import QRCodeIcon from "./icon/QRCode";
import ReportsIcon from "./icon/Reports";
import OrderHistoryIcon from "./icon/OrderHistory";
import DashboardIcon from "./icon/Dashboard";
import SquareIcon from "./icon/SquareLogo";
import { SubscriptionIcon } from "./icon/SubscriptionIcon";
import * as URLS from "../const/URL.const";
import { EposLogo } from "./icon/EposLogo";
import { SalesTaxIcon } from "./icon/SalesTaxIcon";
import { DiscountsIcon } from "./icon/DiscountsIcon";
import { UserManagementIcon } from "./icon/UserManagementIcon";
import { PERMISSIONS } from "../const/permissions.const";
import { ReactComponent as ReviewsIcon } from "../assets/images/icon-reviews-star.svg";

export interface ISidebarItem {
  key: string;
  text: string;
  url?: string;
  icon?: JSX.Element;
  requiredPermission?: PERMISSIONS;
}

export interface ISidebarItemGroup extends ISidebarItem {
  items: {
    [key: string]: ISidebarItem;
  };
}
export interface ISidebarItems {
  [key: string]: ISidebarItem | ISidebarItemGroup;
}

export const MenuContainerTabsNested: ISidebarItems = {
  DASHBOARD: {
    key: "DASHBOARD",
    text: "sidebarMenu.dashboard",
    url: URLS.ANALYTICS_DASHBOARD_URL,
    icon: <DashboardIcon />,
    requiredPermission: PERMISSIONS.REPORTING,
  },
  DETAILS: {
    key: "DETAILS",
    text: "sidebarMenu.details",
    url: URLS.PROFILE_DETAILS_URL,
    icon: <DetailsIcon />,
  },
  PAYMENTSADULT: {
    key: "PAYMENTS_ADULT",
    text: "sidebarMenu.payments",
    icon: <PaymentsIcon />,
    requiredPermission: PERMISSIONS.BILLING_AND_PAYMENT,
    items: {
      PAYMENTADULT: {
        key: "PAYMENTADULT",
        text: "sidebarMenu.payments",
        url: URLS.PROFILE_PAYMENTS_URL,
      },
      OPENBANKING: {
        key: "OPENBANKING",
        text: "sidebarMenu.openbanking",
        url: URLS.OPEN_BANKING_URL,
      },
    },
  },
  PAYMENTS: {
    key: "PAYMENTS",
    text: "sidebarMenu.payments",
    url: URLS.PROFILE_PAYMENTS_URL,
    icon: <PaymentsIcon />,
    requiredPermission: PERMISSIONS.BILLING_AND_PAYMENT,
  },

  EPOSNOW: {
    key: "EPOSNOW",
    text: "sidebarMenu.eposNow",
    url: URLS.PROFILE_EPOS_NOW,
    icon: <EposLogo />,
  },
  MENU_SYNC: {
    key: "MENU_SYNC",
    text: "sidebarMenu.menuSync",
    url: URLS.PROFILE_MENU_SYNC,
    icon: <EposLogo />,
  },
  TAXES: {
    key: "TAXES",
    text: "sidebarMenu.taxes",
    icon: <SalesTaxIcon />,
    url: URLS.TAXES_URL,
  },
  PRODUCTS: {
    key: "PRODUCTS",
    text: "sidebarMenu.products",
    icon: <ProductsIcon />,
    items: {
      SUBCATEGORIES: {
        key: "SUBCATEGORIES",
        text: "sidebarMenu.subcategories",
        url: URLS.PRODUCTS_SUBCATEGORIES,
      },
      ITEMS: {
        key: "ITEMS",
        text: "sidebarMenu.items",
        url: URLS.PRODUCTS_ITEMS_URL,
      },
      EXTRAS: {
        key: "EXTRAS",
        text: "sidebarMenu.extras",
        url: URLS.PRODUCTS_EXTRAS,
      },
      PREFERENCES: {
        key: "PREFERENCES",
        text: "sidebarMenu.preferences",
        url: URLS.PRODUCTS_PREFERENCE,
      },
      MANAGE_MENU: {
        key: "MANAGE_MENU",
        text: "sidebarMenu.menus",
        url: URLS.PRODUCTS_MANAGE_MENU_URL,
      },
    },
  },

  SETTINGS: {
    key: "SETTINGS",
    text: "sidebarMenu.settings",
    icon: <SettingsIcon />,
    items: {
      TRADING_TIMES: {
        key: "TRADING_TIMES",
        text: "sidebarMenu.tradingTimes",
        url: URLS.PROFILE_TRADING_TIMES_URL,
      },
      VENUE_SETTINGS: {
        key: "VENUE_SETTINGS",
        text: "sidebarMenu.venueSettings",
        url: URLS.PROFILE_SETTINGS_URL,
      },
      ORDER_SETTINGS: {
        key: "ORDER_SETTINGS",
        text: "sidebarMenu.orderSettings",
        url: URLS.PROFILE_ORDER_SETTINGS_URL,
      },
      VENUEIMAGES: {
        key: "VENUEIMAGES",
        text: "sidebarMenu.venueImages",
        url: URLS.PROFILE_VENUE_IMAGES,
      },
      EXTERNAL_LINKS: {
        key: "EXTERNAL_LINKS",
        text: "sidebarMenu.externalLinks",
        url: URLS.PROFILE_EXTERNAL_LINKS,
      },
      PRINTER_SETTINGS: {
        key: "PRINTER_SETTINGS",
        text: "sidebarMenu.printerSettings",
        url: URLS.PROFILE_PRINTER_SETTINGS,
      }
    },
  },
  USER_MANAGEMENT: {
    key: "USER_MANAGEMENT",
    text: "sidebarMenu.userManagement",
    url: URLS.USER_MANAGEMENT,
    icon: <UserManagementIcon />,
  },
  DISCOUNTS: {
    key: "DISCOUNTS",
    text: "sidebarMenu.discounts",
    icon: <DiscountsIcon />,
    url: URLS.DISCOUNTS_URL,
  },
  QRCODE: {
    key: "QRCODE",
    text: "sidebarMenu.qrCode",
    url: URLS.PROFILE_QR_CODE,
    icon: <QRCodeIcon />,
    items: {
      VENUE_URL: {
        key: "VENUE_URL",
        text: "sidebarMenu.venueURL",
        url: URLS.PROFILE_VENUE_URL,
      },
      DOWNLOAD_QR_CODE: {
        key: "DOWNLOAD_QR_CODE",
        text: "sidebarMenu.downloadQR",
        url: URLS.PROFILE_DOWNLOAD_QR_CODE,
      },
    },
  },
  SUBSCRIPTIONS: {
    key: "SUBSCRIPTION",
    text: "sidebarMenu.subscription",
    url: URLS.SUBSCRIPTION_URL,
    icon: <SubscriptionIcon />,
    requiredPermission: PERMISSIONS.BILLING_AND_PAYMENT,
  },
  REPORTS: {
    key: "REPORTS",
    text: "sidebarMenu.reports",
    url: URLS.PROFILE_REPORTS_URL,
    icon: <ReportsIcon />,
    requiredPermission: PERMISSIONS.REPORTING,
  },
  CUSTOMERS: {
    key: "CUSTOMERS",
    text: "sidebarMenu.customers",
    url: URLS.CUSTOMERS,
    icon: <CustomersIcon />,
    requiredPermission: PERMISSIONS.REPORTING,
  },
  REVIEWS: {
    key: "REVIEWS",
    text: "sidebarMenu.reviews",
    url: URLS.REVIEWS_URL,
    icon: <ReviewsIcon width="21px" height="20px" />,
    requiredPermission: PERMISSIONS.REPORTING,
  },
  ORDER_HISTORY: {
    key: "ORDER_HISTORY",
    text: "sidebarMenu.orderHistory",
    url: URLS.ORDERS_HISTORY_URL,
    icon: <OrderHistoryIcon />,
  },
  NEW_ORDERS: {
    key: "NEW_ORDERS",
    text: "sidebarMenu.newOrders",
    url: URLS.NEW_ORDERS_URL,
    icon: <ReportsIcon />,
    requiredPermission: PERMISSIONS.ORDER_PROCESSING,
  },
  OPEN_ORDERS: {
    key: "OPEN_ORDERS",
    text: "sidebarMenu.openOrders",
    url: URLS.OPEN_ORDERS_URL,
    icon: <ReportsIcon />,
    requiredPermission: PERMISSIONS.ORDER_PROCESSING,
  },
  SQUARE_SYNC: {
    key: "SQUARE_SYNC",
    text: "sidebarMenu.square",
    url: URLS.SQUARE_SYNC,
    icon: <SquareIcon />,
  },
};

export const MenuContainerTabs = Object.values(MenuContainerTabsNested).reduce(
  (
    total: ISidebarItems,
    item: ISidebarItem | ISidebarItemGroup,
    index: number
  ) => {
    const key = Object.keys(MenuContainerTabsNested)[index];

    return "items" in item
      ? { ...total, [key]: item, ...item.items }
      : { ...total, [key]: item };
  },
  {}
);
